<template>
  <div v-for="(inputParameter, index) in inputParameters">
    <RegistrationSummaryGroup
      v-if="inputParameters && inputParameters[index]!.visible"
      :key="inputParameter.id"
      :label="inputParameter.name"
      :value="inputParameters[index]!.value"
    />
  </div>
  <RegistrationSummaryGroup
    v-if="customer.title"
    :label="$t('dbc-label-title')"
    :value="$t(`dbc-label-title-${customer.title}`)"
  />
  <RegistrationSummaryGroup
    :label="$t('dbc-label-name')"
    :value="customer.firstName"
    v-if="mandatoryFields?.includes('firstName')"
  />
  <RegistrationSummaryGroup
    :label="$t('dbc-label-lastname')"
    :value="customer.lastName"
    v-if="mandatoryFields?.includes('lastName')"
  />
  <RegistrationSummaryGroup
    :label="$t('dbc-label-birthdate')"
    :value="birthDate"
    v-if="mandatoryFields?.includes('birthdate')"
  />
  <RegistrationSummaryGroup
    :label="$t('dbc-label-zipcode')"
    :value="customer.zipCode"
    v-if="customer.zipCode && mandatoryFields?.includes('zipCode')"
  />
  <RegistrationSummaryGroup
    :label="$t('dbc-label-mobile-phone')"
    :value="parsedPhoneNumber?.number?.e164"
    v-if="parsedPhoneNumber && mandatoryFields?.includes('mobile')"
  />
  <RegistrationSummaryGroup
    :label="$t('dbc-label-email')"
    :value="customer.email"
    v-if="mandatoryFields?.includes('mail')"
  />
  <RegistrationSummaryGroup
    :label="$t('dbc-label-password')"
    :value="customer.password"
    :isHidden="true"
    v-if="mandatoryFields?.includes('password')"
  />
</template>

<script setup lang="ts">
import type { ParsedPhoneNumber } from 'awesome-phonenumber'
import dayjs from 'dayjs'

const props = defineProps<{
  customer: RegistrationPersonalData
  inputParameters: TariffParameter[] | undefined
  mandatoryFields: string[] | undefined
  parsedPhoneNumber: ParsedPhoneNumber | undefined
}>()

const birthDate = dayjs(props.customer.birthDate, 'DD.MM.YYYY').format(
  'DD.MM.YYYY'
)
</script>
